var header = document.querySelector('header'); //header animation

if (header) {
  header.classList.add('first-visit-animation');
  setTimeout(function () {
    //remove the animation class
    header.classList.remove('first-visit-animation'); //make the header visible

    header.classList.remove('opacity-0');
  }, 1000);
}